var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/WindowViewer.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import OSDViewer from '../containers/OpenSeadragonViewer';
import WindowCanvasNavigationControls from '../containers/WindowCanvasNavigationControls';
import ManifestoCanvas from '../lib/ManifestoCanvas';
/**
 * Represents a WindowViewer in the mirador workspace. Responsible for mounting
 * OSD and Navigation
 */

export var WindowViewer =
/*#__PURE__*/
function (_Component) {
  _inherits(WindowViewer, _Component);

  /** */
  function WindowViewer(props) {
    var _this;

    _classCallCheck(this, WindowViewer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowViewer).call(this, props));
    _this.state = {};
    return _this;
  }
  /** */


  _createClass(WindowViewer, [{
    key: "componentDidMount",

    /**
     * componentDidMount - React lifecycle method
     * Request the initial canvas on mount
     */
    value: function componentDidMount() {
      var _this$props = this.props,
          currentCanvases = _this$props.currentCanvases,
          fetchInfoResponse = _this$props.fetchInfoResponse,
          fetchAnnotation = _this$props.fetchAnnotation,
          receiveAnnotation = _this$props.receiveAnnotation;

      if (!this.infoResponseIsInStore()) {
        currentCanvases.forEach(function (canvas) {
          var manifestoCanvas = new ManifestoCanvas(canvas);
          var imageResource = manifestoCanvas.imageResource;

          if (imageResource) {
            fetchInfoResponse({
              imageResource: imageResource
            });
          }

          manifestoCanvas.processAnnotations(fetchAnnotation, receiveAnnotation);
        });
      }
    }
    /**
     * componentDidUpdate - React lifecycle method
     * Request a new canvas if it is needed
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          currentCanvasId = _this$props2.currentCanvasId,
          currentCanvases = _this$props2.currentCanvases,
          view = _this$props2.view,
          fetchInfoResponse = _this$props2.fetchInfoResponse,
          fetchAnnotation = _this$props2.fetchAnnotation,
          receiveAnnotation = _this$props2.receiveAnnotation;

      if (prevProps.view !== view || prevProps.currentCanvasId !== currentCanvasId && !this.infoResponseIsInStore()) {
        currentCanvases.forEach(function (canvas) {
          var manifestoCanvas = new ManifestoCanvas(canvas);
          var imageResource = manifestoCanvas.imageResource;

          if (imageResource) {
            fetchInfoResponse({
              imageResource: imageResource
            });
          }

          manifestoCanvas.processAnnotations(fetchAnnotation, receiveAnnotation);
        });
      }
    }
    /**
     * infoResponseIsInStore - checks whether or not an info response is already
     * in the store. No need to request it again.
     * @return [Boolean]
     */

  }, {
    key: "infoResponseIsInStore",
    value: function infoResponseIsInStore() {
      var currentCanvases = this.props.currentCanvases;
      var responses = this.currentInfoResponses();

      if (responses.length === currentCanvases.length) {
        return true;
      }

      return false;
    }
    /**
     * currentInfoResponses - Selects infoResponses that are relevent to existing
     * canvases to be displayed.
     */

  }, {
    key: "currentInfoResponses",
    value: function currentInfoResponses() {
      var _this$props3 = this.props,
          currentCanvases = _this$props3.currentCanvases,
          infoResponses = _this$props3.infoResponses;
      return currentCanvases.map(function (canvas) {
        return infoResponses[new ManifestoCanvas(canvas).imageId];
      }).filter(function (infoResponse) {
        return infoResponse !== undefined && infoResponse.isFetching === false && infoResponse.error === undefined;
      });
    }
    /**
     * Return an image information response from the store for the correct image
     */

  }, {
    key: "tileInfoFetchedFromStore",
    value: function tileInfoFetchedFromStore() {
      var currentCanvases = this.props.currentCanvases;
      var responses = this.currentInfoResponses().map(function (infoResponse) {
        return infoResponse.json;
      }); // Only return actual tileSources when all current canvases have completed.

      if (responses.length === currentCanvases.length) {
        return responses;
      }

      return [];
    }
    /**
     * Renders things
     */

  }, {
    key: "render",
    value: function render() {
      var windowId = this.props.windowId;
      var hasError = this.state.hasError;

      if (hasError) {
        return React.createElement(React.Fragment, null);
      }

      return React.createElement(OSDViewer, {
        tileSources: this.tileInfoFetchedFromStore(),
        windowId: windowId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        },
        __self: this
      }, React.createElement(WindowCanvasNavigationControls, {
        key: "canvas_nav",
        windowId: windowId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129
        },
        __self: this
      }));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);

  return WindowViewer;
}(Component);